import { Features } from "@linkfluence/models/feature";
import { Notification } from "@linkfluence/models/notification";
import { User } from "@linkfluence/models/user";

type Modals = Record<string, boolean>;

interface Panel {
  id: string;
  params?: {
    [key: string]: any;
  };
}

export enum Key {
  Notification = "__notifications",
  Modal = "__modal",
  User = "user",
  Panel = "__panel",
  Features = "features",
}

export interface State {
  [Key.Notification]: Notification[];
  [Key.Modal]: Modals;
  [Key.User]: User;
  [Key.Panel]: Panel;
  [Key.Features]: Features;
}
